import { Skeleton } from '@components/core-ui/Skeleton';

export const SkeletonCard = () => (
  <div
    aria-hidden="true"
    className="relative flex min-h-[220px] w-[260px] min-w-[230px] flex-col rounded-[10px] bg-[var(--color-surface)] shadow-[0_8px_10px_var(--color-shadow)]"
    data-testid="subscription-card-skeleton"
  >
    <div className="px-5 pb-[60px] pt-5">
      <Skeleton className="mt-1 h-[18px] w-[120px]" />
      <Skeleton className="mt-3 h-[34px] w-24 rounded-lg" />
      <div className="mt-3.5 flex items-center gap-3">
        <Skeleton className="h-10 w-16" />
        <div className="h-[41px] border-r border-[var(--color-border)]" />
        <Skeleton className="h-10 w-16" />
      </div>
      <Skeleton className="mt-3.5 h-3 w-[110px]" />
    </div>
    <div className="absolute inset-x-5 bottom-0 flex h-10 items-center justify-center border-t border-[var(--color-border)]">
      <Skeleton className="h-3.5 w-[72px]" />
    </div>
  </div>
);
